import { t } from "@/i18n-js/instance";
import { Button } from "@circle-react-uikit/Button";
import { Modal } from "@circle-react-uikit/ModalV2";
import { Typography } from "@circle-react-uikit/Typography";
import { I18N_LOCALE_ROOT } from "./constants";

interface BlockedDowngradeScheduledStateProps {
  onClose: () => void;
}

export const BlockedDowngradeScheduledState = ({
  onClose,
}: BlockedDowngradeScheduledStateProps) => (
  <>
    <Modal.Header>
      <Modal.Title>
        {t(`${I18N_LOCALE_ROOT}.blocked_downgrade_scheduled.title`)}
      </Modal.Title>
      <Modal.HeaderActions>
        <Modal.CloseButton onClick={onClose} />
      </Modal.HeaderActions>
    </Modal.Header>
    <Modal.Body>
      <div className="flex flex-col gap-4">
        <Typography.BodyMd>
          {t(`${I18N_LOCALE_ROOT}.blocked_downgrade_scheduled.description`)}
        </Typography.BodyMd>
        <Typography.BodyMd color="text-light">
          {t(`${I18N_LOCALE_ROOT}.blocked_downgrade_scheduled.explanation`)}
        </Typography.BodyMd>
      </div>
    </Modal.Body>
    <Modal.Footer>
      <div className="flex flex-row justify-end">
        <Button variant="primary" onClick={onClose}>
          {t(`${I18N_LOCALE_ROOT}.blocked_downgrade_scheduled.button`)}
        </Button>
      </div>
    </Modal.Footer>
  </>
);
